import PropTypes from 'prop-types';
import React from 'react';
import {
  FormattedMessage,
  defineMessages,
  intlShape,
  injectIntl,
} from 'react-intl';

import Form from 'brastrap/common/form/Form';
import FieldInput from 'brastrap/common/field-input/FieldInput';
import FieldSet from 'brastrap/common/fieldset/Fieldset';
import Button from 'brastrap/common/button/Button';
import Link from 'brastrap/containers/link/LinkContainer';
import Messages from 'brastrap/containers/messages/MessagesContainer';

const messages = defineMessages({
  emailPlaceholder: { id: 'placeholder.email', defaultMessage: 'Email' },
  passwordPlaceholder: {
    id: 'placeholder.password',
    defaultMessage: 'Password',
  },
  login: { id: 'button.login', defaultMessage: 'Login' },
  forgotPassword: {
    id: 'login-form.forgot-password',
    defaultMessage: 'Forgotten your password?',
  },
});

const LoginForm = props => {
  const {
    fields: { email, password },
    intl: { formatMessage },
  } = props;

  return (
    <Form className="c-login-form" onSubmit={props.handleSubmit} method="post">
      <Messages target="login" />
      {props.message}

      <FieldSet>
        <FieldInput
          {...email}
          label={formatMessage(messages.emailPlaceholder)}
          required
          id="email"
          type="email"
          note={email.error}
        />
        <FieldInput
          {...password}
          label={formatMessage(messages.passwordPlaceholder)}
          required
          id="password"
          type="password"
          note={password.error}
        />
      </FieldSet>

      <Form.Actions>
        <Button
          submit
          disabled={props.isFetching}
          label={formatMessage(messages.login)}
          modifiers={['login']}
        />
        <Link className={'u-margin-left'} href="/reset-password/">
          <FormattedMessage {...messages.forgotPassword} />
        </Link>
      </Form.Actions>
    </Form>
  );
};

LoginForm.propTypes = {
  fields: PropTypes.shape({
    email: PropTypes.object,
    password: PropTypes.object,
  }),
  handleSubmit: PropTypes.func.isRequired,
  message: PropTypes.object,
  intl: intlShape,
  isFetching: PropTypes.bool,
};

export default injectIntl(LoginForm);
